<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                CONTRATO -
                <strong>
                    {{ contrato.vcCodigoEstruturado }} -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="contratoElaboracao() || aditivarContrato() || this.permiteAlterarTipoAditivo">
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="numeroContrato">Número do contrato</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="numeroContrato"
                                placeholder="Digite o número do contrato"
                                v-model="codigoEstruturado"
                                :state="
                                    $v.codigoEstruturado.$error ? false : null
                                "
                                @input.native="$v.codigoEstruturado.$touch()"
                                v-mask="'AA###/##'"
                                :disabled="aditivarContrato() || this.permiteAlterarTipoAditivo"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O número do contrato é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Gestor</label>
                        <b-form-select
                            :disabled="permiteAlterarTipoAditivo"
                            :options="funcionarios"
                            v-model="codSolicitante"
                            text-field="nome"
                            value-field="codFuncionario"
                            @input="$v.codSolicitante.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Unidade</label>
                        <b-form-select
                            :disabled="permiteAlterarTipoAditivo"
                            :options="unidades"
                            v-model="codUnidade"
                            text-field="nome"
                            value-field="codUnidade"
                            @input="$v.codUnidade.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label>Tipo do Contrato</label>
                        <b-form-select
                            :disabled="permiteAlterarTipoAditivo"
                            :options="tipoContratoOptions"
                            v-model="tipoContratoId"
                            text-field="descricao"
                            value-field="tipoContratoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label>Garantia</label>
                        <b-form-select
                            :disabled="permiteAlterarTipoAditivo"
                            :options="garantiaOptions"
                            v-model="flGarantiaContratual"
                            text-field="descrGarantia"
                            value-field="flGarantia"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="flGarantiaContratual === 1">
                    <b-form-group
                        :state="$v.percGarantia.$error ? false : null"
                        invalid-feedback="O percentual da garantia é obrigatório"
                    >
                        <label>Valor %</label>
                        <money
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="percGarantia"
                            v-bind="money"
                            class="form-control text-right"
                        ></money>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="false">
                    <b-form-group>
                        <label>Tipo do Movimento</label>
                        <b-form-select
                            :options="tipoMovimentoOptions"
                            v-model="tipoMovimento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Categoria do Contrato</label>
                        <b-form-select
                            :disabled="permiteAlterarTipoAditivo"
                            :options="categorias"
                            v-model="categoriaId"
                            text-field="descricao"
                            value-field="categoriaId"
                            @input="$v.categoriaId.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="5"
                    v-if="permiteAlterarTipoAditivo"    
                >
                    <b-form-group>
                        <label>Tipo do aditivo</label>
                        <multi-select
                            :options="tipoAditivoOptions"
                            :selected-options="tiposAditivoSelecionados"
                            @select="selecionar"
                            @input.native="
                                $v.tiposAditivoSelecionados.$touch()
                            "
                            :state="
                                $v.tiposAditivoSelecionados.$error
                                    ? false
                                    : null
                            "
                        ></multi-select>
                        <b-form-invalid-feedback
                            >O tipo aditivo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Objeto do Contrato</label>
                        <b-form-textarea
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="objetoContrato"
                            :rows="4"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.vigenciaInicio.$error ? false : null"
                        invalid-feedback="Data do início da vigência é obrigatória"
                    >
                        <label>Vigência Início</label>
                        <date-picker
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="vigenciaInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.vigenciaFim.$error ? false : null"
                        invalid-feedback="Data do fim da vigência é obrigatória"
                    >
                        <label>Vigência Fim</label>
                        <date-picker
                            v-model="vigenciaFim"
                            :disabled="permiteAlterarTipoAditivo"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.prazoInicio.$error ? false : null"
                        invalid-feedback="Data do início do prazo é obrigatória"
                    >
                        <label>Prazo Execução Início</label>
                        <date-picker
                            v-model="prazoInicio"
                            :disabled="permiteAlterarTipoAditivo"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.prazoInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.prazoFim.$error ? false : null"
                        invalid-feedback="Data do fim do prazo é obrigatória"
                    >
                        <label>Prazo Execução Fim</label>
                        <date-picker
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="prazoFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.prazoFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Envio ao Fornecedor</label>
                        <date-picker
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="dtEnvioFornecedor"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtEnvioFornecedor.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Retorno do Fornecedor</label>
                        <date-picker
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="dtRetornoFornecedor"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtRetornoFornecedor.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Envio para Diretoria</label>
                        <date-picker
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="dtEnvioDiretoria"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtEnvioDiretoria.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Retorno da Diretoria</label>
                        <date-picker
                            :disabled="permiteAlterarTipoAditivo"
                            v-model="dtRetornoDiretoria"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtRetornoDiretoria.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento() || atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{ labelJustificativa }}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="2"
                            @input.native="
                                $v.justificativaApostilamento.$touch()
                            "
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{ textoInfoJustificativa }} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './ContratosServicos'
import { situacaoContrato } from './SituacaoContrato'
import { MultiSelect } from 'vue-search-select'
import { tiposAditivo } from './TiposAditivo'

export default {
    components: {
        MultiSelect
    },

    data() {
        return {
            contrato: {},
            erros: [],
            codigoEstruturado: '',
            operacao: '',
            codSolicitante: null,
            funcionarios: [],
            codUnidade: null,
            unidades: [],
            vigenciaInicio: null,
            vigenciaFim: null,
            prazoInicio: null,
            prazoFim: null,
            dtEnvioFornecedor: null,
            dtRetornoFornecedor: null,
            dtEnvioDiretoria: null,
            dtRetornoDiretoria: null,
            flGarantiaContratual: 0,
            percGarantia: 0,
            objetoContrato: '',
            garantiaOptions: [
                { flGarantia: 0, descrGarantia: 'NÃO' },
                { flGarantia: 1, descrGarantia: 'SIM' }
            ],
            tipoMovimentoOptions: ['1.1.80', '1.1.15', '1.1.79'],
            tipoContratoOptions: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            tipoContratoId: 0,
            tipoMovimento: '1.1.80',
            justificativaApostilamento: '',
            apostilar: null,
            labelJustificativa: '',
            textoInfoJustificativa: '',
            categoriaId: 0,
            categorias: [],
            tipoAditivoOptions: tiposAditivo,
            tiposAditivoSelecionados: [],
            tipoAditivo: ''
        }
    },

    methods: {
        voltar() {
            this.erros = []
            if (
                this.vigenciaInicio !=
                    this.$moment(this.contrato.dtInicioVigencia).format(
                        'DD/MM/YYYY'
                    ) ||
                this.vigenciaFim !=
                    this.$moment(this.contrato.dtFimVigencia).format(
                        'DD/MM/YYYY'
                    ) ||
                this.objetoContrato != this.contrato.vcObjetoContrato
            ) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        confirmaSalvar() {
            if (this.permiteAlterarTipoAditivo && !this.verificaTiposAditivo()) {
                return
            }

            let acao = ''
            let titulo = ''
            if (
                (this.contratoElaboracao() || this.atualizacaoContrato()) &&
                !this.$route.params.apostilar
            ) {
                acao = 'a atualização'
                titulo = 'Atualização'
            } else if (this.apostilamento()) {
                acao = 'o apostilamento'
                titulo = 'Apostilamento'
            }

            this.$swal({
                title: titulo,
                html: `Confirma ${acao} para o contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        procuraTipoAditivo(value) {
            return this.tiposAditivoSelecionados.find((x) => x.value == value)
        },

        verificaTiposAditivo() {
            this.erros = []
            if (
                this.tiposAditivoSelecionados.length > 3 ||
                (this.procuraTipoAditivo(2) && this.procuraTipoAditivo(4))
            ) {
                this.erros.push('Combinação incorreta dos Tipos de Aditivo!')
                return false
            }
            return true
        },

        modificaPropiedadesObjetos(tiposAditivo) {
            this.tiposAditivo = []
            tiposAditivo.forEach((element) => {
                let tpAtv = {
                    idTipoAditivo: element.value,
                    vcDescTipoAditivo: element.text
                }
                this.tiposAditivo.push(tpAtv)
            })
        },

        selecionar(itens) {
            this.tiposAditivoSelecionados = itens
            this.erros = []
            this.modificaPropiedadesObjetos(this.tiposAditivoSelecionados)
        },

        salvar() {
            this.$store.dispatch('addRequest')            
            let apostilamentoAtualizacaoDto = {
                idContrato: this.contrato.idContrato,
                codSolicitante: this.codSolicitante,
                codUnidade: this.codUnidade,
                dtInicioVigencia: this.$moment(
                    this.vigenciaInicio,
                    'DD/MM/YYYY'
                ),
                dtFimVigencia: this.$moment(this.vigenciaFim, 'DD/MM/YYYY'),
                dtInicioPrazoExecucao: this.$moment(
                    this.prazoInicio,
                    'DD/MM/YYYY'
                ),
                dtFimPrazoExecucao: this.$moment(this.prazoFim, 'DD/MM/YYYY'),
                dtEnvioFornecedor: this.dtEnvioFornecedor
                    ? this.$moment(this.dtEnvioFornecedor, 'DD/MM/YYYY')
                    : null,
                dtRetornoFornecedor: this.dtRetornoFornecedor
                    ? this.$moment(this.dtRetornoFornecedor, 'DD/MM/YYYY')
                    : null,
                dtEnvioDiretoria: this.dtEnvioDiretoria
                    ? this.$moment(this.dtEnvioDiretoria, 'DD/MM/YYYY')
                    : null,
                dtRetornoDiretoria: this.dtRetornoDiretoria
                    ? this.$moment(this.dtRetornoDiretoria, 'DD/MM/YYYY')
                    : null,
                flGarantiaContratual: this.flGarantiaContratual,
                nuPercentGarantia: this.percGarantia,
                vcObjetoContrato: this.objetoContrato,
                tipoContratoId: this.tipoContratoId,
                tipoMovimento: this.tipoMovimento,
                isApostilamento: this.apostilar,
                categoriaId: this.categoriaId,
                TiposAditivo: this.tiposAditivo
            }

            if (this.contratoElaboracao() || this.aditivarContrato() || this.permiteAlterarTipoAditivo) {
                apostilamentoAtualizacaoDto.justificativaApostilamento = null
                apostilamentoAtualizacaoDto.vcCodigoEstruturado =
                    this.codigoEstruturado
                apostilamentoAtualizacaoDto.isAditivo = this.aditivarContrato()
                ContratosServicos.atualizarContrato(
                    apostilamentoAtualizacaoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.mensagemSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else if (this.apostilamento()) {
                apostilamentoAtualizacaoDto.justificativaApostilamento =
                    this.justificativaApostilamento
                ContratosServicos.apostilarContrato(
                    apostilamentoAtualizacaoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.mensagemSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorIdApostilar(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                        this.verificaOperacao()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencheFormulario(data) {
            this.contrato = data
            this.codigoEstruturado = data.vcCodigoEstruturado
            this.unidades = data.unidades
            this.funcionarios = data.funcionarios
            this.codSolicitante = data.codSolicitante
            this.codUnidade = data.codUnidade
            this.categorias = data.categorias
            this.categoriaId = data.categoriaId

            if (
                data.dtInicioVigencia != undefined &&
                data.dtFimVigencia != undefined &&
                data.dtInicioPrazoExecucao != undefined &&
                data.dtFimPrazoExecucao != undefined &&
                data.dtEnvioFornecedor != undefined &&
                data.dtRetornoFornecedor != undefined &&
                data.dtEnvioDiretoria != undefined &&
                data.dtRetornoDiretoria != undefined
            ) {
                this.vigenciaInicio = this.$moment(
                    data.dtInicioVigencia
                ).format('DD/MM/YYYY')
                this.vigenciaFim = this.$moment(data.dtFimVigencia).format(
                    'DD/MM/YYYY'
                )
                this.prazoInicio = this.$moment(
                    data.dtInicioPrazoExecucao
                ).format('DD/MM/YYYY')
                this.prazoFim = this.$moment(data.dtFimPrazoExecucao).format(
                    'DD/MM/YYYY'
                )
                this.dtEnvioFornecedor = this.$moment(
                    data.dtEnvioFornecedor
                ).format('DD/MM/YYYY')
                this.dtRetornoFornecedor = this.$moment(
                    data.dtRetornoFornecedor
                ).format('DD/MM/YYYY')
                this.dtEnvioDiretoria = this.$moment(
                    data.dtEnvioDiretoria
                ).format('DD/MM/YYYY')
                this.dtRetornoDiretoria = this.$moment(
                    data.dtRetornoDiretoria
                ).format('DD/MM/YYYY')
            }

            this.flGarantiaContratual = data.flGarantiaContratual
            this.percGarantia = data.nuPercentGarantia
                ? data.nuPercentGarantia
                : 0
            this.objetoContrato = data.vcObjetoContrato
            this.tipoContratoId = data.idTipoContrato
            this.tipoMovimento = data.tipoMovimento
                ? data.tipoMovimento
                : '1.1.80'
            this.definirTipoContratoOptions(data)

            if (this.permiteAlterarTipoAditivo) {
                this.selecionar(data.tiposAditivo)
            }
        },

        definirTipoContratoOptions(contrato) {
            if (
                contrato.temFaseDemanda &&
                !contrato.temFaseEntrega &&
                !contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 1,
                    descricao: 'POR DEMANDA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                !contrato.temFaseDemanda &&
                contrato.temFaseEntrega &&
                !contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 3,
                    descricao: 'POR ENTREGA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                !contrato.temFaseDemanda &&
                !contrato.temFaseEntrega &&
                contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 2,
                    descricao: 'PARCELA FIXA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                (contrato.temFaseDemanda && contrato.temFaseEntrega) ||
                (contrato.temFaseDemanda && contrato.temFaseParcelaFixa) ||
                (contrato.temFaseEntrega && contrato.temFaseParcelaFixa) ||
                (contrato.temFaseDemanda &&
                    contrato.temFaseEntrega &&
                    contrato.temFaseParcelaFixa)
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else {
                this.tipoContratoOptions.push({
                    tipoContratoId: 1,
                    descricao: 'POR DEMANDA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 2,
                    descricao: 'PARCELA FIXA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 3,
                    descricao: 'POR ENTREGA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            }
        },

        mensagemSucesso() {
            let acao = ''
            if (
                (this.contratoElaboracao() || this.atualizacaoContrato()) &&
                !this.apostilar
            ) {
                acao = 'atualizado'
            } else if (this.apostilamento()) {
                acao = 'salvo'
            }

            this.$toast.success(
                `Registro ${acao} com sucesso!`,
                'OK',
                this.$toastConfig.success
            )
            this.voltar()
        },

        registrosInalterados() {
            return (
                this.codigoEstruturado == this.contrato.vcCodigoEstruturado &&
                this.codSolicitante == this.contrato.codSolicitante &&
                this.codUnidade == this.contrato.codUnidade &&
                this.objetoContrato == this.contrato.vcObjetoContrato &&
                this.vigenciaInicio ==
                    this.$moment(this.contrato.dtInicioVigencia).format(
                        'DD/MM/YYYY'
                    ) &&
                this.vigenciaFim ==
                    this.$moment(this.contrato.dtFimVigencia).format(
                        'DD/MM/YYYY'
                    ) &&
                this.prazoInicio ==
                    this.$moment(this.contrato.dtInicioPrazoExecucao).format(
                        'DD/MM/YYYY'
                    ) &&
                this.prazoFim ==
                    this.$moment(this.contrato.dtFimPrazoExecucao).format(
                        'DD/MM/YYYY'
                    ) &&
                this.dtEnvioFornecedor ==
                    this.$moment(this.contrato.dtEnvioFornecedor).format(
                        'DD/MM/YYYY'
                    ) &&
                this.dtRetornoFornecedor ==
                    this.$moment(this.contrato.dtRetornoFornecedor).format(
                        'DD/MM/YYYY'
                    ) &&
                this.dtEnvioDiretoria ==
                    this.$moment(this.contrato.dtEnvioDiretoria).format(
                        'DD/MM/YYYY'
                    ) &&
                this.dtRetornoDiretoria ==
                    this.$moment(this.contrato.dtRetornoDiretoria).format(
                        'DD/MM/YYYY'
                    ) &&
                this.flGarantiaContratual ==
                    this.contrato.flGarantiaContratual &&
                this.percGarantia ==
                    (this.contrato.nuPercentGarantia
                        ? this.contrato.nuPercentGarantia
                        : 0) &&
                this.tipoContratoId == this.contrato.idTipoContrato &&
                this.tipoMovimento == this.contrato.tipoMovimento &&
                this.categoriaId == this.contrato.categoriaId &&
                !this.tipoAditivoAlterado
            )
        },

        validaPercentualGarantia() {
            if (
                (this.flGarantiaContratual === 1 && this.percGarantia > 0) ||
                (this.flGarantiaContratual === 0 && this.percGarantia === 0)
            ) {
                return true
            }
            return false
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return this.situacoesVigenteDistribuido()
        },

        contratoElaboracao() {              
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        verificaOperacao() {
            if (this.apostilamento() && this.apostilar) {
                this.operacao = 'APOSTILAR'
                this.labelJustificativa = 'do Apostilamento'
                this.textoInfoJustificativa = 'apostilamento'
            } else if (
                this.contratoElaboracao() ||
                this.atualizacaoContrato()
            ) {
                this.operacao = 'ATUALIZAR'
            }
        },

        verificaCampoApostilamento() {
            if (this.apostilamento() && this.apostilar) {
                if (this.justificativaApostilamento != '') {
                    return true
                }
            } else if (this.contratoElaboracao() || this.aditivarContrato() || this.permiteAlterarTipoAditivo) {
                return true
            } else if (this.atualizacaoContrato() && !this.apostilar) {
                if (this.justificativaApostilamento != '') {
                    return true
                }
            }
            return false
        },

        verificaCampoNumeroContrato() {
            if (this.apostilamento()) {
                return true
            } else if (
                (this.contratoElaboracao() || this.aditivarContrato() || this.permiteAlterarTipoAditivo) &&
                this.codigoEstruturado.length == 8
            ) {
                return true
            }
            return false
        }
    },

    created() {
        this.apostilar =
            this.$route.params.apostilar != undefined
                ? this.$route.params.apostilar
                : false
        this.obterContrato()
    },

    computed: {
        desabilitarBtnSalvar() {
            if (this.contratoElaboracao() || this.atualizacaoContrato() || this.permiteAlterarTipoAditivo) {                
                return this.$v.$invalid
            } else {
                if (this.$v.$invalid) return true
                else if (this.justificativa == '') return true

                return false
            }
        },

        permiteAlterarTipoAditivo() {
            return this.$temAcessoView('CONT-ADITIV-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
        },

        tipoAditivoAlterado() {
            if ( this.tiposAditivoSelecionados.length > 0
                && this.tiposAditivoSelecionados.length != this.contrato.tiposAditivo.length) {
                return true
            } 
            var alterado = false
            this.tiposAditivoSelecionados.forEach(element => {
                var tipo = this.contrato.tiposAditivo.find(x => element.value == x.value)
                if (tipo == undefined) {
                    alterado = true
                }
            });
            return alterado
        }
    },

    watch: {
        flGarantiaContratual() {
            if (this.flGarantiaContratual === 0) {
                this.percGarantia = 0
            }
        }
    },

    validations: {
        idContrato: {
            contratoAlterado() {
                return !this.registrosInalterados()
            }
        },
        objetoContrato: {
            required
        },
        codSolicitante: {
            required
        },
        codUnidade: {
            required
        },
        vigenciaInicio: {
            required
        },
        vigenciaFim: {
            required
        },
        prazoInicio: {
            required
        },
        prazoFim: {
            required
        },        
        percGarantia: {
            required,
            validaPercentualGarantia() {
                return this.validaPercentualGarantia()
            }
        },
        justificativaApostilamento: {
            verificaCampoApostilamento() {
                return this.verificaCampoApostilamento()
            }
        },
        codigoEstruturado: {
            verificaSituacao() {
                return this.verificaCampoNumeroContrato()
            }
        },
        tiposAditivoSelecionados: {
            requerTipoAditivo() {
                if (this.permiteAlterarTipoAditivo) {
                    return this.tiposAditivoSelecionados.length > 0
                }
                return true
            }
        },
    }
}
</script>
